<script>
    import { fly, slide, fade } from "svelte/transition";
    import { routingInfo } from "../script/common";
    import { onDestroy } from "svelte";
    import {
        SPort,
        Pinter,
        UserCredential,
        RoutinchInfo,
    } from "../script/store";

    export let expanded;

    let avalibleRoutingLinks = Object.keys(routingInfo).reduce((acc, key) => {
        acc[routingInfo[key].id] = {
            shown: false,
        };
        return acc;
    }, {});

    let routingMap = {};
    RoutinchInfo.subscribeMap((map) => {
        routingMap = map;
    });

    function expand() {
        expanded = !expanded;
    }
    function generateActionHandle(route) {
        return () => {
            RoutinchInfo.setSwitch(route);
        };
    }
    let usedPort = null;
    SPort.subscribe((newPort) => {
        if (!newPort) {
            usedPort = null;
            return;
        }
        usedPort = newPort;
    });
    let usedUserInfo = null;
    UserCredential.subscribe((userInfo) => {
        if (!userInfo) {
            usedUserInfo = null;
            return;
        }
        usedUserInfo = userInfo;
        Object.keys(avalibleRoutingLinks).forEach((val) => {
            avalibleRoutingLinks[val].shown = false;
        });
        usedUserInfo.roleInfo.avalibleDialogs.forEach((avalibleRouting) => {
            avalibleRoutingLinks[avalibleRouting.id].shown = true;
        });
    });
    let usedPrinterInfo = null;
    Pinter.subscribe((printerInfo) => {
        if (!printerInfo) {
            usedPrinterInfo = null;
            return;
        }
        usedPrinterInfo = printerInfo;
    });

    /* onDestroy(readerDestructor); */
</script>

<div class="root">
    <div class="content">
        <slot />
    </div>
    {#if expanded}
        <div transition:fade={{ duration: 300 }} class="overlay" />
        <!--  on:click={expand} -->
        <div class="sidePlaceholder" />
        <div
            transition:fly={{ duration: 300, x: -250, opacity: 1 }}
            class="side"
        >
            <div class="header">
                <img style="width: 100%;" src="asset/tanix_logo.png" />
            </div>
            <!-- <div
                class="sideElement"
                on:click={generateActionHandle(routingInfo.TERMINAL)}
            >
                <span class="material-icons"> code </span>
                <div class="sideElementText">
                    <p>Terminál</p>
                    <span class="underLine" />
                </div>
            </div> -->
            {#if avalibleRoutingLinks[routingInfo.SETINGS.id].shown}
                <div
                    class="sideElement"
                    class:activeRoute={routingInfo.SETINGS.id in routingMap}
                    on:click={generateActionHandle(routingInfo.SETINGS)}
                >
                    <span class="material-icons"> settings </span>
                    <div class="sideElementText">
                        <p>Nastavení</p>
                        <span class="underLine" />
                    </div>
                </div>
            {/if}
            {#if avalibleRoutingLinks[routingInfo.SESSION_INFO.id].shown}
                <div
                    class="sideElement"
                    class:activeRoute={routingInfo.SESSION_INFO.id in
                        routingMap}
                    on:click={generateActionHandle(routingInfo.SESSION_INFO)}
                >
                    <span class="material-icons"> event_note </span>
                    <div class="sideElementText">
                        <p>Zakázky</p>
                        <span class="underLine" />
                    </div>
                </div>
            {/if}
            {#if avalibleRoutingLinks[routingInfo.MESURMENT_INFO.id].shown}
                <div
                    class="sideElement"
                    class:activeRoute={routingInfo.MESURMENT_INFO.id in
                        routingMap}
                    on:click={generateActionHandle(routingInfo.MESURMENT_INFO)}
                >
                    <span class="material-icons"> view_list </span>
                    <div class="sideElementText">
                        <p><!-- Správa -->Správa</p>
                        <span class="underLine" />
                    </div>
                </div>
            {/if}
            {#if avalibleRoutingLinks[routingInfo.MESURMENT.id].shown}
                <div
                    class="sideElement"
                    class:activeRoute={routingInfo.MESURMENT.id in routingMap}
                    on:click={generateActionHandle(routingInfo.MESURMENT)}
                >
                    <span class="material-icons"> thermostat </span>
                    <div class="sideElementText">
                        <p>Měření</p>
                        <span class="underLine" />
                    </div>
                </div>
            {/if}
            {#if avalibleRoutingLinks[routingInfo.SUPPORT.id].shown}
                <div
                    class="sideElement"
                    class:activeRoute={routingInfo.SUPPORT.id in routingMap}
                    on:click={generateActionHandle(routingInfo.SUPPORT)}
                >
                    <span class="material-icons"> contact_support </span>
                    <div class="sideElementText">
                        <p>Pomocník</p>
                        <span class="underLine" />
                    </div>
                </div>
            {/if}

            <div class="footerElement">
                <div class="statusBox">
                    {#if !usedPort}
                        <span
                            class="material-icons-outlined"
                            style="color: var(--footerErrColor);"
                        >
                            usb
                        </span>
                        <span>WIKA Nepřipojena</span>
                    {:else}
                        <span
                            class="material-icons-outlined"
                            style="color: var(--footerSuccesColor);"
                        >
                            usb
                        </span>
                        <span>{usedPort.meta.name}</span>
                    {/if}
                </div>
                <div class="statusBox">
                    {#if !usedUserInfo}
                        <span
                            class="material-icons-outlined"
                            style="color: var(--footerErrColor);"
                        >
                            <!-- cloud -->
                            account_circle
                        </span>
                        <span>Databáze Nepřipojena</span>
                    {:else}
                        <span
                            class="material-icons-outlined"
                            style="color: var(--footerSuccesColor);"
                        >
                            account_circle
                        </span>
                        <span>{usedUserInfo.userName}</span>
                    {/if}
                </div>
                <div class="statusBox">
                    {#if !usedPrinterInfo}
                        <span
                            class="material-icons-outlined"
                            style="color: var(--footerErrColor);"
                        >
                            print
                        </span>
                        <span>Tiskárna Nepřipojena</span>
                    {:else}
                        <span
                            class="material-icons-outlined"
                            style="color: var(--footerSuccesColor);"
                        >
                            print
                        </span>
                        <span>{usedPrinterInfo.name}</span>
                    {/if}
                </div>
            </div>
        </div>
    {/if}
</div>

<style>
    .root {
        /* width: 100vw; */
        width: 100%;
        height: 100vh;
        display: grid;
        grid-template-columns: auto 1fr;
        --sideWidth: 13rem;
    }
    .header {
        background: var(--prim);
        padding: 0.5rem 1rem;
    }
    .side {
        background: white;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        width: var(--sideWidth);
        display: flex;
        flex-direction: column;
    }
    .sidePlaceholder {
        /* grid-column: 1;
        grid-row: 1; */
        grid-column: 1 / span 1;
        grid-row: 1 / spam 1;
    }
    .content {
        /* width: 100%;
        grid-column: 2; */
        grid-column: 2 / span 2;
        grid-row: 1 / spam 1;
        min-height: 100%;
        position: relative;
    }

    .sideElement {
        position: relative;
        display: flex;
        align-items: center;
        padding: 1rem 1rem;
        margin: 0.3rem 0.8rem;
        font-size: 1.1rem;
    }
    .sideElement::before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 0;
        transition: width 200ms linear;
        background: var(--back_D1);
        clip-path: polygon(
            0 0,
            calc(100% - 0.7rem) 0,
            100% 50%,
            calc(100% - 0.7rem) 100%,
            0 100%
        );
    }
    .sideElement .material-icons {
        padding-right: 5px;
        z-index: 10;
    }
    .sideElement p {
        border-bottom: solid var(--back_D12) 2px;
    }
    .sideElementText {
        position: relative;
        z-index: 10;
    }
    .underLine {
        position: absolute;
        left: 0;
        bottom: 0;
        /* right: 0; */
        width: 0;
        height: 3px;
        background: var(--prim);
        transition: width cubic-bezier(0.55, 0.09, 0.68, 0.53) 0.2s;
    }
    .sideElement:hover::before {
        width: 100%;
    }
    /* .sideElement:hover .underLine {
        width: 100%;
    } */
    .activeRoute .underLine {
        width: 100%;
    }

    .footerElement {
        margin-top: auto;
        --footerErrColor: var(--err);
        --footerSuccesColor: var(--prim_L2);
    }

    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
    }

    .statusBox {
        display: flex;
        align-items: center;
        margin: 1rem 0.5rem;
        padding: 0.5rem;
        border: solid var(--back_D15) 1px;
        /* border: solid var(--prim) 2px; */
        /* background: #fafafa; */
        text-align: center;
        font-size: 0.8rem;
    }
    .statusBox .material-icons-outlined {
        margin-right: 0.7rem;
        font-size: 1.7rem;
    }

    .sidePlaceholder {
        width: var(--sideWidth);
    }
    .overlay {
        display: none;
    }
    /* @media only screen and (min-width: 800px) {
        .sidePlaceholder {
            width: var(--sideWidth);
        }
        .overlay {
            display: none;
        }
    } */
</style>
